export const environment = {
  production: false,
  apiBaseUrl: 'https://apidev.festaria-members.jp',
  apiVersion: 'v1',
  useNewApi: true,
  legacyMode: false,
  debugMode: true,
  jwtStorageKey: 'festaria_jwt_token',
  sessionTimeout: 60
};